import { render, staticRenderFns } from "./FieldInfoTypeD.vue?vue&type=template&id=14a20ad1&scoped=true&"
import script from "./FieldInfoTypeD.vue?vue&type=script&lang=js&"
export * from "./FieldInfoTypeD.vue?vue&type=script&lang=js&"
import style0 from "./FieldInfoTypeD.vue?vue&type=style&index=0&id=14a20ad1&prod&scoped=true&lang=scss&"
import style1 from "./FieldInfoTypeD.vue?vue&type=style&index=1&id=14a20ad1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a20ad1",
  null
  
)

export default component.exports